import { http_client } from "@/plugins/http_client";

const base = "/api/consultorias/perfil";

export const getPerfilConsultor = () =>
  http_client(`${base}`);

export const getPerfilConsultorCompletar = () =>
  http_client(`${base}/completar`);

export const getNominaConsultor = (id, urlAppend = {}) =>
  http_client(
    `/api/consultorias/mnt/nomina/${id}${Object.keys(urlAppend).length ? `?${new URLSearchParams(urlAppend)}` : ""}`
  );

export const getNominaEntregables = (nomina) =>
  http_client(`/api/consultorias/nomina/${nomina}/entregables`);

export const getConsultoria = (id) =>
  http_client(`/api/consultorias/mnt/consultorias/${id}`);

export const buscarHistorialConsultorias = (body, urlAppend = {}) =>
  http_client(
    `/api/consultorias/mnt/consultorias/search${Object.keys(urlAppend).length ? `?${new URLSearchParams(urlAppend)}` : ""}`,
    body,
    "post"
  );

export const crearDatosGenerales = (body) =>
  http_client(`${base}/datos-generales`, body, "post");

export const actualizarDatosGenerales = (id, body) =>
  http_client(`${base}/datos-generales/${id}`, body, "put");

export const crearFamiliar = (body) =>
  http_client(`${base}/familiares`, body, "post");

export const actualizarFamiliar = (id, body) =>
  http_client(`${base}/familiares/${id}`, body, "put");

export const eliminarFamiliar = (id) =>
  http_client(`${base}/familiares/${id}`, {}, "delete");

 export const crearDocumento = async (body) =>
  await http_client(`${base}/documentos`,body, "post", {
    "Content-Type": "multipart/form-data",
  }); 

export const actualizarDocumento = (id, body, headers) =>
  http_client(`${base}/documentos/${id}`, body, "post",  headers || {
    "Content-Type": "multipart/form-data",
  });

export const eliminarDocumento = (id) =>
  http_client(`${base}/documentos/${id}`, {}, "delete");

export const crearAlergia = (body) =>
  http_client(`${base}/alergias`, body, "post");

export const actualizarAlergia = (id, body) =>
  http_client(`${base}/alergias/${id}`, body, "put");

export const eliminarAlergia = (id) =>
  http_client(`${base}/alergias/${id}`, {}, "delete");

export const crearEnfermedad = (body) =>
  http_client(`${base}/enfermedades`, body, "post");

export const actualizarEnfermedad = (id, body) =>
  http_client(`${base}/enfermedades/${id}`, body, "put");

export const eliminarEnfermedad = (id) =>
  http_client(`${base}/enfermedades/${id}`, {}, "delete");

export const crearDiscapacidad = (body) =>
  http_client(`${base}/discapacidades`, body, "post");

export const actualizarDiscapacidad = (id, body) =>
  http_client(`${base}/discapacidades/${id}`, body, "put");

export const eliminarDiscapacidad = (id) =>
  http_client(`${base}/discapacidades/${id}`, {}, "delete");

export const crearFormacionAcademica = (body) =>
  http_client(`${base}/formacion-academica`, body, "post");

export const actualizarFormacionAcademica = (id, body) =>
  http_client(`${base}/formacion-academica/${id}`, body, "put");

export const eliminarFormacionAcademica = (id) =>
  http_client(`${base}/formacion-academica/${id}`, {}, "delete");

export const crearCapacidad = (body) =>
  http_client(`${base}/capacidades`, body, "post",{
    "Content-Type": "multipart/form-data",
  });

export const actualizarCapacidad = (id, body, headers) =>
  http_client(`${base}/capacidades/${id}`, body, "post", headers || {
    "Content-Type": "multipart/form-data",
  });

export const eliminarCapacidad = (id) =>
  http_client(`${base}/capacidades/${id}`, {}, "delete");

export const crearOtroAspecto = (body) =>
  http_client(`${base}/otros`, body, "post");

export const actualizarOtroAspecto = (id, body) =>
  http_client(`${base}/otros/${id}`, body, "put");

export const eliminarOtroAspecto = (id) =>
  http_client(`${base}/otros/${id}`, {}, "delete");

export const getDocumento = (data) =>
  http_client("/api/ctl_tipo_documento/search?", data, "post");

export const getParentesco = (data) =>
  http_client("/api/ctl_parentesco/search?", data, "post");


export const getPais = (data) =>
  http_client("/api/ctl_pais/search?", data, "post");

export const searchConsultora = (body = {}) =>
  http_client("/api/consultorias/perfil/historial-pagos", body, "post");


export default {
  getPerfilConsultorCompletar,
};